import { useUserDetailsStore } from '@/stores/useUserDetails';
const useIsUserManageOnly = () => {
  const userStore = useUserDetailsStore();
  const isUserManageOnly = userStore?.accountLevel?.toLowerCase() === 'manage only';

  return { isUserManageOnly };
};

export default useIsUserManageOnly;
